<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

  $(function () {
  $(document).scroll(function () {
	  var $nav = $(".custom_header_style");
	  $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
	});
});